// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Vue from 'vue';

// Store
import StoreModule from '@/store/index';

// Consts
import { ErrorCode, HttpStatusCode } from '@/common/consts';

export default {
  install(Vue: any) {
    Vue.config.errorHandler = (error: any, vm: Vue, info: any) => {
      StoreModule.hideLoader();
      // エラー通知用のコード
      let code = '';
      // エラー通知用のメッセージ
      let msg = '';
      // 画面用のメッセージキー
      let dispMsg = undefined;
      // 認証トークンは隠蔽
      hideAuthHeader(error);
      // bodyは隠蔽。個人情報のマスクができていないため
      hideBody(error);
      const msgParam = {
        info: info,
        config: error.config ? JSON.stringify(error.config, undefined, 2) : '',
        stack: error.stack || error
      } as {
        status?: number;
        message?: string;
        config?: string;
        info?: any;
        stack: any;
      };
      const dispMsgParam = {} as { status?: number };
      if (error && error.response) {
        // HTTPエラー
        dispMsgParam.status = error.response.status;
        msgParam.status = error.response.status;
        switch (error.response.status) {
          case HttpStatusCode.BAD_REQUEST:
            code = ErrorCode.SFR0101;
            break;
          case HttpStatusCode.UNAUTHORIZED:
            // 何らかの不具合で認証済みにも関わらずエラーとなる場合
            code = ErrorCode.SFR0102;
            break;
          case HttpStatusCode.FORBIDDEN:
            code = ErrorCode.SFR0103;
            break;
          case HttpStatusCode.NOT_FOUND:
            code = ErrorCode.SFR0104;
            break;
          case HttpStatusCode.CONFLICT:
            code = ErrorCode.SFR0105;
            break;
          case HttpStatusCode.UNSUPPORTED_MEDIA_TYPE:
            code = ErrorCode.SFR0106;
            break;
          case HttpStatusCode.INTERNAL_SERVER_ERROR:
            code = ErrorCode.SFR0107;
            break;
          case HttpStatusCode.BAD_GATEWAY:
            code = ErrorCode.SFR0108;
            break;
          case HttpStatusCode.SERVICE_UNAVAILABLE:
            code = ErrorCode.SFR0109;
            break;
          case HttpStatusCode.GATEWAY_TIMEOUT:
            code = ErrorCode.SFR0110;
            break;
          default:
            code = ErrorCode.SFR0111;
            break;
        }
        msgParam.message = ErrorCode.getMsg(code);
        msg = `${vm.$t('errHandler.message.httpError', msgParam)}`;
        dispMsg = ErrorCode.getDispMsgKey(code);
      } else if (error && error.request && !error.response) {
        // ネットワークエラー
        code = ErrorCode.SFR0112;
        msgParam.message = ErrorCode.getMsg(code);
        msg = `${vm.$t('errHandler.message.networkError', msgParam)}`;
        dispMsg = ErrorCode.getDispMsgKey(code);
      } else {
        // その他エラー
        code = ErrorCode.SFR0201;
        msgParam.message = ErrorCode.getMsg(code);
        msg = `${vm.$t('errHandler.message.otherError', msgParam)}`;
      }
      // ログ出力
      logError(vm, () => `${code}: ${msg}`);
      if (dispMsg) {
        // 画面メッセージ表示
        vm.showErrorMessage(`${vm.$t(dispMsg, dispMsgParam)}`);
      }

      // TODO Lambda 移行
      // エラー通知API呼び出し
      // new storeCoreApi.SystemApi(DEFAULT_STORE_CORE_CLIENT_CONFIG)
      //   .errorPost({
      //     code: code,
      //     message: msg,
      //     level: storeCoreApi.PostErrorRequestLevelEnum.WARN
      //   })
      //   .then()
      //   .catch(err => {
      //     // エラー通知のpostの例外は処理できないのでcatchしてログのみ出力させる
      //     logError(vm, () => {
      //       hideAuthHeader(err);
      //       return `${vm.$t('errHandler.message.postError', {
      //         config: err.config
      //           ? JSON.stringify(err.config, undefined, 2)
      //           : '',
      //         stack: err.stack || err
      //       })}`;
      //     });
      //   });
    };
  }
};

/**
 * エラーオブジェクト内の認証トークンを隠蔽する
 * @param error エラーオブジェクト
 */
const hideAuthHeader = (error: any) => {
  if (
    error.config &&
    error.config.headers &&
    error.config.headers.Authorization
  ) {
    error.config.headers.Authorization = '***';
  }
};

/**
 * エラーオブジェクト内のリクエストボディーを隠蔽する
 * @param error エラーオブジェクト
 */
const hideBody = (error: any) => {
  if (error.config && error.config.data) {
    error.config.data = '***';
  }
};

/**
 * エラーログ出力
 * @param messageFunc メッセージ取得関数
 */
const logError = (vm: Vue, messageFunc: () => string) => {
  vm.$log.error(messageFunc());
};
